import React from 'react';
import SmallContainer from './SmallContainer';
import { fmt } from '../../utils/fmtUtils';

const TablaGenerales = props => {
  return (
    <div className="datosGenerales">
      <div className="container content">
        {/* <div className="smallContainer1"> */}
        <SmallContainer
          value={fmt(props.data.data.totales.act.mesesc)}
          text={'MESAS INFORMADAS'}
          percent={props.data.data.totales.act.pmesesc}
        />
        {/* </div>
        <div className="smallContainer2"> */}
        <SmallContainer
          value={fmt(props.data.data.totales.act.votant)}
          text={'VOTANTES'}
          percent={props.data.data.totales.act.pvotant}
        />
        {/* </div> */}
        {/* <SmallContainer
          value={fmt(props.data.data.totales.act.votnma)}
          text={'Tarjetas no marcadas'}
          percent={props.data.data.totales.act.pvotnma}
        />
        <SmallContainer
          value={fmt(props.data.data.totales.act.votnul)}
          text={'Votos Nulos'}
          percent={props.data.data.totales.act.pvotnul}
        /> */}
      </div>
    </div>
  );
};

export default TablaGenerales;
